import React from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import TotalLeaveView from '../components/version-4/viewForms/TotalLeaveView'
import { useTotalLeave } from '../hooks/CompanyConfiguration/useTotalLeave'
import { useCategory } from '../hooks/Features/useCategory'
import { useFeatures } from '../hooks/Features/useFeatures'
import { ROUTES } from '../shared/constants'

function ViewLeaveAllocation() {
  const { getTotalLeave, totalLeave } = useTotalLeave()
  const params = useParams()

  React.useEffect(() => {
    getTotalLeave({ totalLeaveId: params.totalLeaveId })
  }, [params.totalLeaveId])

  return (
    <Layout heading="Leave Allocation" heading2="Info" url1={ROUTES.TOTAL_LEAVE} none>
      {totalLeave ? (
        <HeaderTabLayout
          heading="Leave Allocation"
          content={<TotalLeaveView totalLeave={totalLeave} />}
          view
          url={`/edit-totalLeave/${params.totalLeaveId}`}
        />
      ) : <Loader />}
    </Layout>
  )
}

export default ViewLeaveAllocation
